module.exports = __webpack_public_path__ + "bdf3c74aa183294eafb63b18147028c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/works-with/logos/logo-fitbit.png
// module id = 1787
// module chunks = 1